import { LanguageCourseDisplay } from '@/components/ui/data-display/language-course-display/LanguageCourseDisplay';
import { GridCol } from '@/components/ui/layouts/grids/GridCol';
import { gridCol } from '@mage-ui/styled-system/recipes';

export const LanguageItem = ({ data }) => {
  const { name, iso, alias } = data?.fields || {};
  const niceUrl =
    data?.relations?.LanguagePageLink?.[0]?.meta?.link || data?.meta?.link;

  return (
    <GridCol
      key={data?.meta?.key}
      className={gridCol({
        colSpanS: '6',
        colSpanM: '4',
        colSpanL: '3',
      })}
    >
      <LanguageCourseDisplay
        data={{
          nice_url: niceUrl,
          name,
          iso: alias || iso,
        }}
      />
    </GridCol>
  );
};
